import PropTypes from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>Your appointment is for up to three rooms</li>
    <li>
      If you have any room dimensions or a floor plan prepared pre appointment, your Home Design
      Stylist will be able to use this in your design
    </li>
    <li>
      Feel free to share any research, mood boards or photographs of your space with us, we love to
      see what inspires you
    </li>
    <li>
      After your appointment, you&apos;ll receive a personalised mood board, which we&apos;ll show
      you in a follow-up presentation appointment
    </li>
    <li>
      To find out more about the Home Design service please&nbsp;
      <a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/home-design-service`}>visit our website</a>
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
